function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import BaselineDefs from '../BaselineDefs/BaselineDefs';
import InstallImport from '../InstallImport/InstallImport';
import EventDocs from '../EventDocs/EventDocs';
import PropDocs from '../PropDocs/PropDocs';
import RepoInfo from '../RepoInfo/RepoInfo';
import BundleSize from '../BundleSize/BundleSize';
import SectionContent from '../SectionContent/SectionContent';
import { SVGIcon } from '@homeaway/react-svg';
import { LINK__24 } from '@homeaway/svg-defs';
import "./ComponentPage.css";
import "../Code/CodeTheme.css";
import "../Code/Code.css";

var ComponentPage = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ComponentPage, _Component);

  function ComponentPage(props) {
    return _Component.call(this, props) || this;
  }

  var _proto = ComponentPage.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.anchor) {
      this.scrollToAnchor(this.props.anchor);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.anchor !== prevProps.anchor) {
      this.scrollToAnchor(this.props.anchor);
    } else if (this.props.pathname !== prevProps.pathname && typeof window !== 'undefined') {
      window.scrollTo(0, 0);
    }
  };

  _proto.scrollToAnchor = function scrollToAnchor(anchor) {
    if (anchor && typeof document !== 'undefined') {
      var elem = document.getElementById(anchor);

      if (elem) {
        elem.scrollIntoView();
      }
    }
  }
  /* eslint-disable complexity */
  ;

  _proto.render = function render() {
    var _this$props = this.props,
        bundleSize = _this$props.bundleSize,
        children = _this$props.children,
        componentName = _this$props.componentName,
        demos = _this$props.demos,
        multiDemos = _this$props.multiDemos,
        events = _this$props.events,
        importAll = _this$props.importAll,
        isDefaultExport = _this$props.isDefaultExport,
        isMultiComponentPage = _this$props.isMultiComponentPage,
        local = _this$props.local,
        name = _this$props.name,
        properties = _this$props.properties,
        repoData = _this$props.repoData,
        repository = _this$props.repository,
        sections = _this$props.sections,
        support = _this$props.support,
        tag = _this$props.tag,
        theme = _this$props.theme,
        type = _this$props.type,
        useIframe = _this$props.useIframe; // componentName wasn't always specified so for backwards compatibility
    // fallback to the sanitized name property.

    var compName = componentName || name.trim().replace(/[^0-9a-zA-Z_$]*/g, '');
    var descriptionClassName = classnames('ComponentPage__section-description', {
      'ComponentPage__section-description--with-support': !!support
    });
    var sectionRepoInfoClassName = classnames({
      'ComponentPage__section-with-repo-info': sections && sections[0].type === 'html' && type !== 'guide' && type !== 'design'
    });
    var pageClassNames = classnames('ComponentPage', {
      'ComponentPage--design': this.props.type === 'design'
    });
    var componenSectionNameFragment = /*#__PURE__*/React.createElement(Fragment, null, name + " ", bundleSize && /*#__PURE__*/React.createElement("span", {
      className: "text-400"
    }, /*#__PURE__*/React.createElement(BundleSize, {
      name: compName,
      owner: repoData.owner,
      repoName: repoData.name,
      raw: bundleSize.raw,
      parsed: bundleSize.parsed,
      gzip: bundleSize.gzip,
      modules: bundleSize.modules,
      local: local
    })));
    return /*#__PURE__*/React.createElement("div", {
      className: pageClassNames
    }, /*#__PURE__*/React.createElement(BaselineDefs, null), /*#__PURE__*/React.createElement("section", {
      className: "ComponentPage__content"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ComponentPage__readability"
    }, /*#__PURE__*/React.createElement("article", {
      className: "ComponentPage__article",
      id: compName
    }, type !== 'design' && /*#__PURE__*/React.createElement("section", {
      className: "ComponentPage__section ComponentPage__section-name"
    }, !isMultiComponentPage && /*#__PURE__*/React.createElement("h1", null, componenSectionNameFragment), isMultiComponentPage && /*#__PURE__*/React.createElement("h3", null, componenSectionNameFragment)), /*#__PURE__*/React.createElement("section", {
      className: "ComponentPage__section"
    }, /*#__PURE__*/React.createElement("div", {
      className: sectionRepoInfoClassName
    }, sections && sections[0].type === 'html' && /*#__PURE__*/React.createElement("div", {
      className: "ComponentPage__section-description-container"
    }, type !== 'guide' && type !== 'design' && /*#__PURE__*/React.createElement("aside", {
      className: "ComponentPage__aside pull-right"
    }, repository && /*#__PURE__*/React.createElement(RepoInfo, {
      tagDate: tag.pushedAt,
      tagName: tag.name,
      dependencies: repoData.dependencies,
      peerDependencies: repoData.peerDependencies,
      support: support,
      forks: repository.forks,
      issues: repository.issues,
      owner: repoData.owner,
      name: repoData.name,
      stargazers: repository.stargazers,
      url: repository.url,
      watchers: repository.watchers
    })), /*#__PURE__*/React.createElement("div", {
      className: descriptionClassName,
      key: 'content0',
      dangerouslySetInnerHTML: {
        __html: sections[0].content
      }
    })), type !== 'guide' && type !== 'baseline' && type !== 'design' && /*#__PURE__*/React.createElement(InstallImport, {
      importAll: importAll,
      isDefaultExport: isDefaultExport,
      name: compName,
      packageName: repoData.qualifiedName
    })), sections && /*#__PURE__*/React.createElement(SectionContent, {
      componentName: compName,
      demos: demos,
      multiDemos: multiDemos,
      local: local,
      name: name,
      owner: repoData.owner,
      repoName: repoData.name,
      sections: sections,
      theme: theme,
      useIframe: useIframe
    })), events && Array.isArray(events) && events.length > 0 && /*#__PURE__*/React.createElement("section", {
      className: "ComponentPage__section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ComponentPage__section-anchor-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "position-relative"
    }, /*#__PURE__*/React.createElement("a", {
      "aria-hidden": "true",
      className: "ComponentPage__anchor ComponentPage__anchor--divider",
      href: "#events"
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: "ComponentPage__anchor-icon",
      markup: LINK__24
    }))), /*#__PURE__*/React.createElement(EventDocs, {
      componentName: compName,
      events: events
    }))), properties && Array.isArray(properties) && properties.length > 0 && /*#__PURE__*/React.createElement("section", {
      className: "ComponentPage__section"
    }, /*#__PURE__*/React.createElement("div", {
      className: "ComponentPage__section-anchor-container"
    }, /*#__PURE__*/React.createElement("div", {
      className: "position-relative"
    }, /*#__PURE__*/React.createElement("a", {
      "aria-hidden": "true",
      className: "ComponentPage__anchor ComponentPage__anchor--divider",
      href: "#properties"
    }, /*#__PURE__*/React.createElement(SVGIcon, {
      className: "ComponentPage__anchor-icon",
      markup: LINK__24
    }))), /*#__PURE__*/React.createElement(PropDocs, {
      componentName: compName,
      properties: properties
    }))))), children));
  }
  /* eslint-enable complexity */
  ;

  return ComponentPage;
}(Component);

ComponentPage.propTypes = {
  anchor: PropTypes.string,
  bundleSize: PropTypes.shape({
    raw: PropTypes.number,
    parsed: PropTypes.number,
    gzip: PropTypes.number,
    modules: PropTypes.arrayOf(PropTypes.shape({
      src: PropTypes.string,
      raw: PropTypes.number,
      parsed: PropTypes.number,
      gzip: PropTypes.number
    }))
  }),
  componentName: PropTypes.string,
  demos: PropTypes.arrayOf(PropTypes.shape({
    clearStyle: PropTypes.bool,
    content: PropTypes.string,
    noInline: PropTypes.bool,
    scope: PropTypes.object
  })),
  multiDemos: PropTypes.arrayOf(PropTypes.shape({
    demo: PropTypes.shape({
      clearStyle: PropTypes.bool,
      content: PropTypes.string,
      noInline: PropTypes.bool,
      minHeight: PropTypes.string,
      demoViews: PropTypes.shape({
        defaultView: PropTypes.oneOf(['xs', 'lg']),
        lg: PropTypes.bool,
        xs: PropTypes.bool
      })
    }),
    description: PropTypes.string,
    key: PropTypes.string,
    label: PropTypes.html
  })),
  events: PropTypes.arrayOf(PropTypes.shape({
    event: PropTypes.string,
    method: PropTypes.string,
    baseFilename: PropTypes.string,
    fields: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    })),
    options: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      value: PropTypes.string
    }))
  })),
  importAll: PropTypes.bool,
  isDefaultExport: PropTypes.bool,
  isMultiComponentPage: PropTypes.bool,
  local: PropTypes.bool,
  name: PropTypes.string.isRequired,
  pathname: PropTypes.string,
  properties: PropTypes.arrayOf(PropTypes.shape({
    defaultValue: PropTypes.shape({
      computed: PropTypes.bool,
      value: PropTypes.string
    }),
    name: PropTypes.string,
    required: PropTypes.bool,
    type: PropTypes.shape({
      value: PropTypes.arrayOf(PropTypes.string)
    })
  })),
  repoData: PropTypes.shape({
    dependencies: PropTypes.object,
    name: PropTypes.string,
    owner: PropTypes.string,
    peerDependencies: PropTypes.object,
    qualifiedName: PropTypes.string
  }).isRequired,
  repository: PropTypes.shape({
    avatarUrl: PropTypes.string,
    forks: PropTypes.number,
    issues: PropTypes.number,
    stargazers: PropTypes.number,
    url: PropTypes.string,
    watchers: PropTypes.number
  }),
  sections: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape({
    // HTML
    content: PropTypes.string,
    type: PropTypes.string
  }), PropTypes.shape({
    // LiveDemo
    content: PropTypes.string,
    type: PropTypes.string,
    demoViews: PropTypes.shape({
      defaultView: PropTypes.oneOf(['xs', 'lg']),
      lg: PropTypes.bool,
      xs: PropTypes.bool
    }),
    hideChrome: PropTypes.bool,
    minHeight: PropTypes.string
  }), PropTypes.shape({
    // MultiDemo
    content: PropTypes.string,
    type: PropTypes.string,
    demos: PropTypes.arrayOf(PropTypes.string)
  }), PropTypes.shape({
    // StaticDemo
    content: PropTypes.string,
    type: PropTypes.string,
    contentHighlighted: PropTypes.string,
    demoOnly: PropTypes.bool,
    htmlOnly: PropTypes.bool
  })])),
  support: PropTypes.shape({
    contact: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string
    }),
    issues: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      url: PropTypes.string
    })
  }),
  tag: PropTypes.shape({
    name: PropTypes.string,
    pushedAt: PropTypes.string
  }),
  theme: PropTypes.string,
  type: PropTypes.string.isRequired,
  family: PropTypes.string.isRequired,
  category: PropTypes.string.isRequired,
  useIframe: PropTypes.bool
};
ComponentPage.defaultProps = {
  theme: 'gt'
};
export default ComponentPage;
//# sourceMappingURL=ComponentPage.js.map